import { render, staticRenderFns } from "./sg-img.vue?vue&type=template&id=63c43c5c&scoped=true&"
import script from "./sg-img.vue?vue&type=script&lang=js&"
export * from "./sg-img.vue?vue&type=script&lang=js&"
import style0 from "./sg-img.vue?vue&type=style&index=0&id=63c43c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c43c5c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlaceholderImg: require('/opt/build/repo/storefront/components/legacy/global/placeholder-img.vue').default})
